export enum RouteNames {
  Tickets = 'event-tickets',
  TicketCreate = 'event-ticket-create',
  Ticket = 'event-ticket',
  TicketEdit = 'event-ticket-edit',
  TicketTemplates = 'ticket-templates',
  TicketTemplateCreate = 'ticket-template-create',
  TicketTemplate = 'ticket-template',
  TicketTemplateEdit = 'ticket-template-edit',
  PromoCodes = 'promo-codes',
  PromoCodeCreate = 'promo-code-create',
  PromoCode = 'promo-code',
  PromoCodeEdit = 'promo-code-edit',
  Orders = 'orders',
  Order = 'order',
  OrderCreate = 'order-create',
  OrderEdit = 'order-edit',
  Badges = 'event-badges',
  BadgesTemplates = 'event-badges-templates',
  BadgesTemplateCreate = 'event-badges-template-create',
  BadgesTemplate = 'event-badges-template',
  BadgesPrint = 'event-badges-print',
  MeetingSettings = 'meeting-settings',
  MeetingLocations = 'meeting-locations',
}
